import { DOCUMENT } from "@angular/common";
import { Directive, ElementRef, HostListener, Inject } from "@angular/core";

@Directive({
  selector: "[taSelectText]",
  exportAs: "taSelectText"
})
export class SelectTextDirective {
  private windowRef: Window;

  constructor(
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private documentRef: any
  ) {
    this.windowRef = this.documentRef.defaultView!;
  }

  @HostListener("click")
  onInteraction(): void {
    this.selectNodeContents();
  }

  deselect(): void {
    const selection = this.windowRef.getSelection();
    if (selection != null) {
      selection.removeAllRanges();
    }
  }

  private selectNodeContents(): void {
    const selection = this.windowRef.getSelection();
    if (selection != null) {
      selection.removeAllRanges();
      selection.addRange(this.nodeContents());
    }
  }

  private nodeContents(): Range {
    const range = this.documentRef.createRange();
    range.selectNodeContents(this.elementRef.nativeElement);
    return range;
  }
}
